import * as actionTypes from '../types/documents';

export function getDocumentsNextNumber(payload) {
  return {
    type: actionTypes.GET_DOCUMENTS_NEXT_NUMBER,
    payload
  };
}
export function getDocumentsNextNumberSuccess(payload) {
  return {
    type: actionTypes.GET_DOCUMENTS_NEXT_NUMBER_SUCCESS,
    payload
  };
}
export function getDocumentsNextNumberFail(payload) {
  return {
    type: actionTypes.GET_DOCUMENTS_NEXT_NUMBER_FAIL,
    payload
  };
}

export function delDocumentsNextNumber(payload) {
  return {
    type: actionTypes.DEL_DOCUMENTS_NEXT_NUMBER,
    payload
  };
}

export function getActsByDocType(payload) {
  return {
    type: actionTypes.GET_ACTS_BY_DOCTYPE,
    payload
  };
}
export function getActsByDocTypeSuccess(payload) {
  return {
    type: actionTypes.GET_ACTS_BY_DOCTYPE_SUCCESS,
    payload
  };
}
export function getActsByDocTypeFail(payload) {
  return {
    type: actionTypes.GET_ACTS_BY_DOCTYPE_FAIL,
    payload
  };
}

export function getActsByStock(payload) {
  return {
    type: actionTypes.GET_ACTS_BY_STOCK,
    payload
  };
}
export function getActsByStockSuccess(payload) {
  return {
    type: actionTypes.GET_ACTS_BY_STOCK_SUCCESS,
    payload
  };
}
export function getActsByStockFail(payload) {
  return {
    type: actionTypes.GET_ACTS_BY_STOCK_FAIL,
    payload
  };
}

export function getPiecesByStock(payload) {
  return {
    type: actionTypes.GET_PIECES_BY_STOCK,
    payload
  };
}
export function getPiecesByStockSuccess(payload) {
  return {
    type: actionTypes.GET_PIECES_BY_STOCK_SUCCESS,
    payload
  };
}
export function getPiecesByStockFail(payload) {
  return {
    type: actionTypes.GET_PIECES_BY_STOCK_FAIL,
    payload
  };
}

export function getPiecesByAct(payload) {
  return {
    type: actionTypes.GET_PIECES_BY_ACT,
    payload
  };
}
export function getPiecesByActSuccess(payload) {
  return {
    type: actionTypes.GET_PIECES_BY_ACT_SUCCESS,
    payload
  };
}
export function getPiecesByActFail(payload) {
  return {
    type: actionTypes.GET_PIECES_BY_ACT_FAIL,
    payload
  };
}

export function addPieceToAct(payload) {
  return {
    type: actionTypes.ADD_PIECE_TO_ACT,
    payload
  };
}
export function addPieceToActSuccess(payload) {
  return {
    type: actionTypes.ADD_PIECE_TO_ACT_SUCCESS,
    payload
  };
}
export function addPieceToActFail(payload) {
  return {
    type: actionTypes.ADD_PIECE_TO_ACT_FAIL,
    payload
  };
}
export function addPieceToActClear(payload) {
  return {
    type: actionTypes.ADD_PIECE_TO_ACT_CLEAR,
    payload
  };
}

export function deletePieceFromAct(payload) {
  return {
    type: actionTypes.DELETE_PIECE_FROM_ACT,
    payload
  };
}
export function deletePieceFromActSuccess(payload) {
  return {
    type: actionTypes.DELETE_PIECE_FROM_ACT_SUCCESS,
    payload
  };
}
export function deletePieceFromActFail(payload) {
  return {
    type: actionTypes.DELETE_PIECE_FROM_ACT_FAIL,
    payload
  };
}
export function deletePieceFromActClear(payload) {
  return {
    type: actionTypes.DELETE_PIECE_FROM_ACT_CLEAR,
    payload
  };
}

export function updateAct(payload) {
  return {
    type: actionTypes.UPDATE_ACT,
    payload
  };
}
export function updateActSuccess(payload) {
  return {
    type: actionTypes.UPDATE_ACT_SUCCESS,
    payload
  };
}
export function updateActFail(payload) {
  return {
    type: actionTypes.UPDATE_ACT_FAIL,
    payload
  };
}
export function updateActClear(payload) {
  return {
    type: actionTypes.UPDATE_ACT_CLEAR,
    payload
  };
}

export function deleteAct(payload) {
  return {
    type: actionTypes.DELETE_ACT,
    payload
  };
}
export function deleteActSuccess(payload) {
  return {
    type: actionTypes.DELETE_ACT_SUCCESS,
    payload
  };
}
export function deleteActFail(payload) {
  return {
    type: actionTypes.DELETE_ACT_FAIL,
    payload
  };
}
export function deleteActClear(payload) {
  return {
    type: actionTypes.DELETE_ACT_CLEAR,
    payload
  };
}

export function getAdminActUpdate(payload) {
  return {
    type: actionTypes.GET_ADMIN_ACT_UPDATE,
    payload
  };
}

export function getHolderReportsByStock(payload) {
  return {
    type: actionTypes.GET_HOLDER_REPORTS_BY_STOCK,
    payload
  };
}

export function getHolderReportsByStockSuccess(payload) {
  return {
    type: actionTypes.GET_HOLDER_REPORTS_BY_STOCK_SUCCESS,
    payload
  };
}

export function getHolderReportsByStockFail(payload) {
  return {
    type: actionTypes.GET_HOLDER_REPORTS_BY_STOCK_FAIL,
    payload
  };
}

export function deleteHolderReport(payload) {
  return {
    type: actionTypes.DELETE_HOLDER_REPORT,
    payload
  };
}

export function deleteHolderReportSuccess(payload) {
  return {
    type: actionTypes.DELETE_HOLDER_REPORT_SUCCESS,
    payload
  };
}

export function deleteHolderReportFail(payload) {
  return {
    type: actionTypes.DELETE_HOLDER_REPORT_FAIL,
    payload
  };
}

export function signActsByClient(payload) {
  return {
    type: actionTypes.SIGN_ACTS_BY_CLIENT,
    payload
  };
}

export function signActsByClientSuccess(payload) {
  return {
    type: actionTypes.SIGN_ACTS_BY_CLIENT_SUCCESS,
    payload
  };
}

export function signActsByClientFail(payload) {
  return {
    type: actionTypes.SIGN_ACTS_BY_CLIENT_FAIL,
    payload
  };
}

export function setInitialStateActs(payload) {
  return {
    type: actionTypes.SET_INITIAL_STATE_ACTS,
    payload
  };
}

export function setVisiblePopupSignSelected(payload) {
  return {
    type: actionTypes.SET_VISIBLE_POPUP_SIGN_SELECTED,
    payload
  };
}

export function setSelectedDocItems(payload) {
  return {
    type: actionTypes.SET_SELECTED_DOC_ITEMS,
    payload
  };
}
